import React from 'react';
import {
  Trophy,
  Mic,
  Star,
  Image,
  MessageCircle,
  Calendar,
  Clock,
  MapPin,
  Users,
  Book,
  Film,
  Music,
  Coffee,
  Heart,
  Zap,
  Award,
  Gift,
  Globe,
  Headphones,
  Monitor,
  Palette,
  Camera,
  Tv,
  Gamepad2,
  Briefcase,
  GraduationCap,
  Lightbulb,
  Megaphone,
  Presentation,
  Rocket,
  Shield,
  Target,
  Wrench,
  Tag,
  Layers,
  type LucideProps,
} from 'lucide-react';

const iconMap: Record<string, React.FC<LucideProps>> = {
  trophy: Trophy,
  mic: Mic,
  star: Star,
  image: Image,
  'message-circle': MessageCircle,
  calendar: Calendar,
  clock: Clock,
  'map-pin': MapPin,
  users: Users,
  book: Book,
  film: Film,
  music: Music,
  coffee: Coffee,
  heart: Heart,
  zap: Zap,
  award: Award,
  gift: Gift,
  globe: Globe,
  headphones: Headphones,
  monitor: Monitor,
  palette: Palette,
  camera: Camera,
  tv: Tv,
  'gamepad-2': Gamepad2,
  briefcase: Briefcase,
  'graduation-cap': GraduationCap,
  lightbulb: Lightbulb,
  megaphone: Megaphone,
  presentation: Presentation,
  rocket: Rocket,
  shield: Shield,
  target: Target,
  wrench: Wrench,
  layers: Layers,
  tag: Tag,
};

interface LucideIconProps {
  name: string;
  size?: number;
  className?: string;
}

export const LucideIcon: React.FC<LucideIconProps> = ({
  name,
  size = 16,
  className = '',
}) => {
  const normalizedName = name.toLowerCase().trim();
  const IconComponent = iconMap[normalizedName] || Tag;
  return <IconComponent size={size} className={className} />;
};

export default LucideIcon;
